import React from 'react';
import { Modal } from 'react-bootstrap';
import TermsOfService from '../privacy/TermsOfService';

interface Props {
    isShow: boolean;
    setShow: (eulaShow: boolean) => void;
}
const EulaModal: React.FC<Props> = (props) => {
    return (
        <Modal
            size='lg'
            show={props.isShow}
            onHide={() => props.setShow(false)}
            aria-labelledby='example-modal-sizes-title-lg'
            style={{
                fontFamily: 'Open Sans',
            }}
        >
            <Modal.Header closeButton>
                <Modal.Title id='example-modal-sizes-title-lg'>
                    TERMOS DE SERVIÇO E EULA
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <TermsOfService />
            </Modal.Body>
        </Modal>
    );
};

export default EulaModal;
